module.exports = __webpack_public_path__ + "img/i_04.89296c69.png";